import React from 'react';

const Checkbox = ({ name, value, label, checked, required, onChange, className }) => {
  return (
    <div className={className || 'my-5'}>
      <label className='flex items-center cursor-pointer group'>
        <div className='relative'>
          <input 
            type='checkbox'
            name={name || ''} 
            value={value || ''} 
            checked={checked || false}
            required={required ? true : false}
            onChange={onChange || null}
            className='sr-only peer'
          />
          <div className='w-6 h-6 border-2 border-custom-light-grey rounded bg-custom-charcoal peer-checked:bg-custom-light-blue peer-checked:border-custom-light-blue transition-all duration-200 flex items-center justify-center'>
            <svg 
              className='w-4 h-4 text-white opacity-0 peer-checked:opacity-100 transition-opacity duration-200' 
              fill='none' 
              stroke='currentColor' 
              viewBox='0 0 24 24'
            >
              <path 
                strokeLinecap='round' 
                strokeLinejoin='round' 
                strokeWidth='3' 
                d='M5 13l4 4L19 7'
              />
            </svg>
          </div>
        </div>
        {label && (
          <span className='ml-3 text-white select-none group-hover:text-gray-300 transition-colors'>
            {label}
          </span>
        )}
      </label>
    </div>
  );
};

export default Checkbox;
